// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import { Breadcrumb, Card, Col, Row, Tab } from 'react-bootstrap';

// import custom components
// import sub components
import SalledeclasseListItems from './SalledeclasseListItems';
import SalledeclasseService from '../../services/SalledeclasseService';

const Salledeclasse = () => {
	const [salledeclasses, setSalledeclasses] = useState([]);
	const [show, setShow] = useState(false);

	useEffect(() => {
		SalledeclasseService.getAllSalledeclasse().then((response) => {
			setSalledeclasses(response);
		});
	}, []);

	return (
		<Fragment>
			<Tab.Container defaultActiveKey="list">
				<Row>
					<Col lg={12} md={12} sm={12}>
						<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
							<div className="mb-3 mb-md-0">
								<h1 className="mb-1 h2 fw-bold">
									Salles de classe{' '}
									<span className="fs-5 text-muted">
										{' '}
										({salledeclasses.length})
									</span>
								</h1>
								<Breadcrumb>
									<Breadcrumb.Item href="/">
										Accueil
									</Breadcrumb.Item>
									<Breadcrumb.Item active>Salles de classe</Breadcrumb.Item>
								</Breadcrumb>
							</div>
						</div>
					</Col>
				</Row>

				<Tab.Content>
					<Tab.Pane eventKey="list" className="pb-4">
						<Card className="mb-5 ">
							<Card.Body className="p-0">
								<SalledeclasseListItems />
							</Card.Body>
						</Card>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Fragment>
	);
};
export default Salledeclasse;
